"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  optValue: 'he_him_his',
  optLabel: 'pronouns.he_him_his'
}, {
  optValue: 'she_her_hers',
  optLabel: 'pronouns.she_her_hers'
}, {
  optValue: 'they_them_theirs',
  optLabel: 'pronouns.they_them_theirs'
}, {
  optValue: 'other',
  optLabel: 'pronouns.other'
}];
exports.default = _default;